// extracted by mini-css-extract-plugin
module.exports = {"main":"WhatYouKnow_main_2GM3a","mobile":"WhatYouKnow_mobile_2cBIg","title":"WhatYouKnow_title_1inFt","content":"WhatYouKnow_content_3bi6k"};